/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Export_Preset_Load_RequiredInputs */



/**
* | output |
* | --- |
* | "You need to select a preset!" |
*
* @param {Video_Export_Export_Preset_Load_RequiredInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_export_preset_load_required = /** @type {((inputs?: Video_Export_Export_Preset_Load_RequiredInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Export_Preset_Load_RequiredInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Vous devez selectionner un prereglage !")
	if (locale === "de") return /** @type {LocalizedString} */ ("Sie müssen eine Voreinstellung auswählen!")
	if (locale === "it") return /** @type {LocalizedString} */ ("Devi selezionare un preset!")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Вам нужно выбрать предустановленный вариант!")
	if (locale === "es") return /** @type {LocalizedString} */ ("¡Necesitas seleccionar un ajuste preestablecido!")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("您需要选择一个预设！")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プリセットを選択する必要があります。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("आपको एक प्रीसेट चुनना होगा!")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Você precisa selecionar uma predefinição!")
	return /** @type {LocalizedString} */ ("You need to select a preset!")
});